import { render } from "./CveBoardDetail.vue?vue&type=template&id=e13295f4"
import script from "./CveBoardDetail.vue?vue&type=script&lang=js"
export * from "./CveBoardDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__